import {
  ActivityRowStats,
  RankedListPanel,
  hasActivityScore,
} from './AnalyticsRankedList';

function AdminRegionActivityLists({ teamRows, onTeamClick }) {
  const sortedTeams = [...teamRows]
    .filter((row) => hasActivityScore(row.relativeScore))
    .sort((a, b) => {
      if (b.relativeScore !== a.relativeScore) return b.relativeScore - a.relativeScore;
      return String(a.teamName).localeCompare(String(b.teamName));
    });

  return (
    <>
      <h2 className="modern-heading analytics-section-heading modern-mb-4">Teams</h2>
      <RankedListPanel
        items={sortedTeams}
        getKey={(row) => row.teamId}
        getLabel={(row) => row.teamName}
        getActivityScore={(row) => row.relativeScore}
        renderMeta={(row) => (
          <ActivityRowStats reflections={row.totalReflections} />
        )}
        onItemClick={onTeamClick}
        emptyMessage="No active teams yet."
      />
    </>
  );
}

export default AdminRegionActivityLists;
